export function sort(items)
{
	items.sort((a, b) =>
	{
		const sortA = a.item?.sort;
		const sortB = b.item?.sort;

		if(sortA === sortB)
		{
			const labelA = getLabel(a);
			const labelB = getLabel(b);

			return labelA.localeCompare(labelB);
		}

		return sortA < sortB ? -1 : 1;
	});

	return items;
}

export function sortExperienceDesc(items)
{
	items.sort((a, b) =>
	{
		const experienceSortA = a.experience?.sort;
		const experienceSortB = b.experience?.sort;

		if (experienceSortA === experienceSortB)
		{
			const sortA = a.item?.sort;
			const sortB = b.item?.sort;

			if (sortA === sortB)
			{
				const labelA = getLabel(a);
				const labelB = getLabel(b);

				return labelA.localeCompare(labelB);
			}

			return sortA < sortB ? -1 : 1;
		}

		return experienceSortA > experienceSortB ? -1 : 1;
	});

	return items;
}

export function sortLabel(items)
{
	items.sort((a, b) =>
	{
		const labelA = getLabel(a);
		const labelB = getLabel(b);

		return labelA.localeCompare(labelB);
	});

	return items;
}

function getLabel(item)
{
	return item.freeText || item.item.label;
}
